import React, { ReactElement, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'
import { COOKIES } from 'src/Utils/globalEnums'
import { getLoginRedirectFromSearch } from 'src/Utils/loginRedirect'
import { LoginPageNew } from './LoginPageNew'

export const LoginPage = (): ReactElement => {
  const location = useLocation()
  const { originalURL, originalEmail } = useMemo(() => {
    const state = location.state as
      | { redirect?: string; originalEmail?: string }
      | undefined
    return {
      originalURL:
        getLoginRedirectFromSearch(location.search) || state?.redirect,
      originalEmail: state?.originalEmail,
    }
  }, [location])

  useEffect(() => {
    // we only want to remove this cookie if the user stays on this page
    // We don't want to remove it from if we are redirecting to log into the app
    const timeoutId = setTimeout(
      () => Cookies.remove(COOKIES.FROM_SIGNUP, { path: '' }),
      2500,
    )
    const cleanup = () => clearTimeout(timeoutId)

    return cleanup
  }, [])

  return (
    <LoginPageNew originalEmail={originalEmail} originalURL={originalURL} />
  )
}
